<template>
  <div class="component-filter-input">
    <div class="inner-wrap">
      <div class="content">
        <vxe-input type="text" v-model="option.data" @keyup="keyupEvent" @input="changeOptionEvent"></vxe-input>
      </div>
      <div class="footer">
        <vxe-button @click="resetEvent" size="mini">{{ $t("button.clear") }}</vxe-button>
        <vxe-button status="primary" @click="confirmEvent" size="mini">{{ $t("button.confirm") }}</vxe-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterInput',
  props: {
    params: Object,
    renderOpts: Object
  },
  data () {
    return {
      column: null,
      option: null
    }
  },
  created () {
    this.load()
    if(this.renderOpts.selectedOptions) {
      this.option.data = this.renderOpts.selectedOptions;
    }
    if(this.column) {
      this.changeOptionEvent();
    }
  },
  methods: {
    load () {
      const { column } = this.params
      const option = column.filters[0]
      this.column = column
      this.option = option
    },
    changeOptionEvent () {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data
      $panel.changeOption(null, checked, option)
    },
    keyupEvent ({ $event }) {
      const { params } = this
      const { $panel } = params
      if ($event.keyCode === 13) {
        $panel.confirmFilter()
      }
    },
    confirmEvent () {
      const { $panel } = this.params
      $panel.confirmFilter()
    },
    resetEvent () {
      const { $panel } = this.params
      $panel.resetFilter()
    }
  }
}
</script>

<style lang="scss">
.component-filter-input {
  padding: 10px;
  .footer{
    margin-top: 5px;
  }
}
</style>